import { AccountCreatedEvent } from '@rematter/frontend-lib-api-client/grpc/crm/v1/account_events_pb';
import { AccountType } from '@rematter/frontend-lib-api-client/grpc/crm/v1/account_pb';
import {
  BadgeField,
  Col,
  FieldDisplay,
  IDField,
  ThemeColor,
} from '@rematter/ui-web';

import { accountTypeLabels } from '../enumLabels';

const getAccountTypeColor = (accountType: AccountType): ThemeColor => {
  switch (accountType) {
    case AccountType.COMMERCIAL:
      return 'primary';
    case AccountType.INDIVIDUAL:
      return 'teal';
    default:
      return 'neutral';
  }
};

type AccountCreatedDetailProps = {
  event: AccountCreatedEvent;
};

export const AccountCreatedDetail = ({ event }: AccountCreatedDetailProps) => {
  const account = event.account;

  if (!account) {
    return (
      <Col className="@AccountCreatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@AccountCreatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Account Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={account.id?.value} />
          <FieldDisplay label="Name" value={account.name} />
          <BadgeField
            label="Account Type"
            value={accountTypeLabels[account.accountType]}
            color={getAccountTypeColor(account.accountType)}
          />
          <BadgeField
            label="Is Customer"
            value={account.isCustomer ? 'Yes' : 'No'}
            color={account.isCustomer ? 'success' : 'neutral'}
          />
          <BadgeField
            label="Is Supplier"
            value={account.isSupplier ? 'Yes' : 'No'}
            color={account.isSupplier ? 'success' : 'neutral'}
          />
          <FieldDisplay label="Email" value={account.email} />
          <FieldDisplay label="Phone" value={account.phone} />
        </div>
      </Col>
    </Col>
  );
};
